import React, { useMemo, useState } from 'react';
import { Search, X } from 'lucide-react';

/**
 * Generic searchable modal for flat lists (exchanges, output coins, etc).
 * The caller supplies how each row looks and how items are matched.
 */
const ListPickerModal = ({
  title,
  items,
  itemKey,
  searchText, // (item) => string to match against
  renderRow, // (item) => JSX for the row's contents
  onClose,
  emptyLabel = 'Nothing to show',
  searchPlaceholder = 'Search...',
}) => {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    if (!query.trim()) return items;
    const q = query.trim().toLowerCase();
    return items.filter((item) => searchText(item).toLowerCase().includes(q));
  }, [items, query, searchText]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        {items.length > 6 && (
          <div className="modal-search">
            <Search size={16} color="var(--ink-400)" />
            <input
              autoFocus
              type="text"
              placeholder={searchPlaceholder}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
        )}

        <div className="modal-body">
          {filtered.length === 0 ? (
            <p className="list-empty">{emptyLabel}</p>
          ) : (
            filtered.map((item) => <React.Fragment key={itemKey(item)}>{renderRow(item)}</React.Fragment>)
          )}
        </div>
      </div>
    </div>
  );
};

export default ListPickerModal;
